import React from 'react';

export default ({theme = 'default', value, label, hasDecimals, displayZero, className, ...rest}) => (
	<label className={`Input Input--${theme}`+(rest.disabled ? ' Input--disabled' : '')+(hasDecimals ? ' min-height' : '')}>
		<h6>{label}</h6>
		<div className='input-container-old'>
			<input value={displayZero ? value : (value || '')} {...rest} className={`${className ? className : ''} ${hasDecimals ? 'with-decimals' : ''}`}/>
			{
				hasDecimals &&
                <div className="input-display-value">{value ? Number(value).toFixed(2) : '0.00'}</div>
			}
        </div>
	</label>
);